import { Actions } from './profile.actions'
import { fromJS } from 'immutable'
import * as ProfileTypes from './profile.types'

export const initialState = fromJS({
  user: {
    isLoading: false,
    data: {},
  },
  updatePassword: {
    isLoading: false,
    validationErrors: {},
    data: {
      existingPassword: '',
      newPassword: '',
    },
  },
})

export function profileReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ProfileTypes.FETCH_PROFILE_REQUEST: {
      return state.setIn(['user', 'isLoading'], true)
    }

    case ProfileTypes.FETCH_PROFILE_SUCCESS: {
      return state
        .setIn(['user', 'isLoading'], false)
        .setIn(['user', 'data'], fromJS(action.payload))
    }

    case ProfileTypes.FETCH_PROFILE_FAILURE: {
      return state.setIn(['updatePassword', 'isLoading'], false)
    }

    case ProfileTypes.UPDATE_PASSWORD_REQUEST: {
      return state.setIn(['updatePassword', 'isLoading'], true)
    }

    case ProfileTypes.UPDATE_PASSWORD_SUCCESS: {
      return state
        .setIn(['updatePassword', 'isLoading'], false)
        .setIn(
          ['updatePassword', 'data'],
          initialState.getIn(['updatePassword', 'data']),
        )
    }

    case ProfileTypes.UPDATE_PASSWORD_FAILURE: {
      return state.setIn(['user', 'isLoading'], false)
    }

    case ProfileTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case ProfileTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
